import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolPipelines = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "a",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h24v24H0z"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 21c-.65 0-1.233-.188-1.75-.563A2.91 2.91 0 0 1 16.175 19H11c-1.1 0-2.042-.392-2.825-1.175C7.392 17.042 7 16.1 7 15s.392-2.042 1.175-2.825C8.958 11.392 9.9 11 11 11h2c.55 0 1.02-.196 1.412-.588C14.804 10.021 15 9.55 15 9c0-.55-.196-1.02-.588-1.412A1.926 1.926 0 0 0 13 7H7.825a3.09 3.09 0 0 1-1.088 1.438A2.852 2.852 0 0 1 5 9a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 2 6c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 5 3c.65 0 1.23.188 1.737.563.509.374.871.854 1.088 1.437H13c1.1 0 2.042.392 2.825 1.175C16.608 6.958 17 7.9 17 9s-.392 2.042-1.175 2.825C15.042 12.608 14.1 13 13 13h-2c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 9 15c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587h5.175a3.09 3.09 0 0 1 1.087-1.438A2.851 2.851 0 0 1 19 15c.833 0 1.542.292 2.125.875S22 17.167 22 18s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 19 21ZM5 7c.283 0 .52-.096.713-.287A.968.968 0 0 0 6 6a.968.968 0 0 0-.287-.713A.968.968 0 0 0 5 5a.968.968 0 0 0-.713.287A.968.968 0 0 0 4 6c0 .283.096.52.287.713.192.191.43.287.713.287Z",
			fill: "currentColor"
		})
	})]
});
export default SvgToolPipelines;
